export default __webpack_public_path__ + "static/media/folding-box-big.8ea276a8.png";